import React, { useState, useEffect, useCallback, useRef } from 'react';

import { Pets } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { 
  Character
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterTransformInput from "@dndComponents/character/transform/CharacterTransformInput";

interface Props {
  character: Character;
  use_transform: boolean;
  show_name?: boolean;
  onChange: () => void;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterTransformButton({
  character,
  use_transform,
  show_name = false,
  onChange,
}: Props) {
  const [open, setOpen] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setReloading(true);
  }, [setReloading]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
      character.subscription_holder.subscribe("Transform", mounted, recalculated);
    }
  }, [character, fetched, setFetched, mounted, recalculated]);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        // drawer_only
        onClose={() => {
          setOpen(false); 
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <CharacterTransformInput
            character={character}
            use_transform={use_transform}
            onChange={onChange}
            // setUseTransform={setUseTransform}
          />
        }
      </ModalOrDrawer>
    );
  }

  const renderName = () => {
    if (show_name && character.transform) {
      const char_interface = character.transform;
      return (
        <>
          { char_interface.transform?.name??"Transform" }{ char_interface.creature ? `: ${char_util.getUseName(char_interface.creature)}` : "" }
        </>
      );
    }
  }
  
  if (show_name && !character.transform) {
    return (
      <>
      </>
    );
  } else {
    return (
      <>
        <Tooltip title="Transforms &amp; Adaptations">
          <span className="vCentered clickable"
            onClick={() => {
              setOpen(true);
            }}>
            <Pets
            />
            { renderName() }
          </span>
        </Tooltip>
        { renderExtras() }
      </>
    ); 
  }
}
